import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FantasyGamePanelComponent } from './components/fantasy-game-panel/fantasy-game-panel.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { FantasyPlayerSelectComponent } from './components/fantasy-player-select/fantasy-player-select.component';
import { RouterModule } from '@angular/router';
import { FantasyHistoryListComponent } from './components/fantasy-history-list/fantasy-history-list.component';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { FantasyHistoryListItemComponent } from './components/fantasy-history-list-item/fantasy-history-list-item.component';
import { FantasyPlayerSelectConfirmComponent } from './components/fantasy-player-select-confirm/fantasy-player-select-confirm.component';
import { InlineSVGModule } from 'ng-inline-svg-2';
import { FantasyLeaderboardComponent } from './components/fantasy-leaderboard/fantasy-leaderboard.component';
import { FantasyGamePanelNextGameComponent } from './components/fantasy-game-panel-next-game/fantasy-game-panel-next-game.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { PipesModule } from '@fgb/portal-component-library/src/lib/pipes';
import { CountdownModule } from '@fgb/portal-component-library/src/lib/shared/countdown';
import { FantasyGameRulesComponent } from './components/fantasy-game-rules/fantasy-game-rules.component';
import { ClubModule } from '../club/club.module';
import { FantasyUpNextComponent } from './components/fantasy-up-next/fantasy-up-next.component';
import { FantasyGamePlayComponent } from './components/fantasy-game-play/fantasy-game-play.component';
import { FantasyGameResultsComponent } from './components/fantasy-game-results/fantasy-game-results.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';
import { DirectivesModule } from '@fgb/portal-component-library/src/lib/directives';
import { LayoutModule } from '../layouts/layout.module';

@NgModule({
  declarations: [
    FantasyGamePanelComponent,
    FantasyPlayerSelectComponent,
    FantasyHistoryListComponent,
    FantasyHistoryListItemComponent,
    FantasyPlayerSelectConfirmComponent,
    FantasyLeaderboardComponent,
    FantasyGamePanelNextGameComponent,
    FantasyGameRulesComponent,
    FantasyUpNextComponent,
    FantasyGamePlayComponent,
    FantasyGameResultsComponent
  ],
  exports: [
    FantasyGamePanelComponent,
    FantasyPlayerSelectComponent,
    FantasyHistoryListComponent,
    FantasyGamePanelNextGameComponent,
    FantasyLeaderboardComponent,
    FantasyGameRulesComponent,
    FantasyUpNextComponent,
    FantasyGamePlayComponent,
    FantasyGameResultsComponent
  ],
  imports: [
    NgbModule,
    RouterModule,
    SharedModule,
    CommonModule,
    CarouselModule,
    PipesModule,
    CountdownModule,
    ClubModule,
    FGBSharedModule,
    DirectivesModule,
    LayoutModule,
    InlineSVGModule.forRoot(),
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: function HttpLoaderFactory(http: HttpClient) {
          return new TranslateHttpLoader(http, './assets/i18n/', '.json');
        },
        deps: [HttpClient],
      },
    }),
  ],
})
export class FantasyModule { }
